import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/* global chrome */

const LoginSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    console.log('LoginSuccess: Token retrieved:', token ? 'exists' : 'not found');
    
    if (typeof chrome !== 'undefined' && chrome.runtime && token) {
      console.log('LoginSuccess: Attempting to send token to extension');
      
      // Try to send token to extension using multiple methods
      const sendTokenToExtension = async () => {
        try {
          // Method 1: Try with the extension ID from manifest (if available)
          const extensionId = chrome.runtime.id;
          console.log('LoginSuccess: Extension ID from runtime:', extensionId);
          
          if (extensionId) {
            chrome.runtime.sendMessage(
              extensionId,
              { 
                type: 'AUTH_TOKEN',
                token: token
              },
              (response) => {
                console.log('LoginSuccess: Response from extension:', response);
                if (chrome.runtime.lastError) {
                  console.log('LoginSuccess: Extension error:', chrome.runtime.lastError);
                  // Fallback: try to store token in extension storage directly
                  chrome.storage.local.set({ authToken: token }, () => {
                    console.log('LoginSuccess: Token stored directly in extension storage');
                  });
                } else if (response && response.success) {
                  console.log('LoginSuccess: Token successfully stored in extension');
                }
                // Add a small delay before redirecting
                setTimeout(() => {
                  navigate('/measurements');
                }, 1000);
              }
            );
          } else {
            // Fallback: try to store token in extension storage directly
            chrome.storage.local.set({ authToken: token }, () => {
              console.log('LoginSuccess: Token stored directly in extension storage');
            });
            setTimeout(() => {
              navigate('/measurements');
            }, 1000);
          }
        } catch (error) {
          console.log('LoginSuccess: Error communicating with extension:', error);
          // Final fallback: try to store token in extension storage directly
          try {
            chrome.storage.local.set({ authToken: token }, () => {
              console.log('LoginSuccess: Token stored directly in extension storage (fallback)');
            });
          } catch (storageError) {
            console.log('LoginSuccess: Could not store token in extension storage:', storageError);
          }
          navigate('/measurements');
        }
      };
      
      sendTokenToExtension();
    } else {
      console.log('LoginSuccess: Chrome runtime not available or no token');
      navigate('/measurements');
    }
  }, [navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>Login Successful!</h2>
      <p>Connecting to extension...</p>
    </div>
  );
};

export default LoginSuccess; 